import { CUSTOMFIELD_TYPE_IDS } from './../constants/typeId';
import { FormControl, FormGroup, Validators } from "@angular/forms";

function processPicklistValues(values): { name: string }[] {
    const fieldValues: { name: string }[] = [];

    for (const value of values) {
        fieldValues.push({ name: value });
    }

    return fieldValues;
}

export function getCustomFormControlFields(customFields: any[]): any {
    const formGroupFields = {};

    customFields?.filter(field=> ![CUSTOMFIELD_TYPE_IDS.FORMULA].includes(field?.formControl?.id)).map(field=>{
        const defaultValue = field?.formControl?.id==CUSTOMFIELD_TYPE_IDS.TOOGLE_BUTTON ? false : null;

        const validations = [];

        if(field.isRequired && ![CUSTOMFIELD_TYPE_IDS.AUTONUMBER].includes(field?.formControl?.id)){
            validations.push(Validators.required);
        }

        if(field?.formControl?.expression && ![CUSTOMFIELD_TYPE_IDS.DATETIMEPICKER,CUSTOMFIELD_TYPE_IDS.AUTONUMBER].includes(field?.formControl?.id)){
            validations.push(Validators.pattern(field?.formControl?.expression));
        }

        formGroupFields[field.name] = new FormControl(defaultValue,validations);

        if (field.formControl) {
            field.formControl.pickListValues = processPicklistValues(field.formControl.pickListValues || []);
        }
    })

    return formGroupFields;
}
